// ==========================
// Version 3 — Hero.js (polish: fluid type, a11y on glows, button types)
// ==========================
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const NAVY = '#0A1A33';
const GOLD = '#C9A44C';
const IVORY = '#FDFCF9';
const WARM_GRAY = '#888888';

export default function Hero() {
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  const startAction = () => {
    if (currentUser) {
      const el = document.getElementById('memory-form');
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      navigate('/register');
    }
  };

  const goMap = () => navigate('/map');

  return (
    <section style={styles.hero}>
      <div style={styles.starGlowTL} aria-hidden="true" />
      <div style={styles.starGlowBR} aria-hidden="true" />

      <div style={styles.inner}>
        <span style={styles.kicker}>Blessed with a Kiss</span>
        <h1 style={styles.title}>The future form of diary</h1>

        <ul style={styles.points} aria-label="Supporting messages">
          <li>We will immortalize your love.</li>
          <li>Your story. Your proof. Forever.</li>
          <li>Leave a kiss. Drop a memory.</li>
          <li>Immortalize your story. Preserve your truth.</li>
        </ul>

        <div style={styles.actions}>
          <button type="button" style={styles.btnPrimary} onClick={startAction}>
            {currentUser ? 'Start a memory' : 'Create your account'}
          </button>
          <button type="button" style={styles.btnGhost} onClick={goMap}>
            Explore the global map
          </button>
        </div>
      </div>
    </section>
  );
}

const styles = {
  hero: {
    position: 'relative',
    overflow: 'hidden',
    background: `radial-gradient(1200px 600px at 20% -10%, rgba(201,164,76,0.18), transparent),
                 radial-gradient(800px 400px at 120% 20%, rgba(201,164,76,0.12), transparent),
                 ${NAVY}`,
    borderBottom: '1px solid rgba(201,164,76,0.25)',
    marginBottom: 16,
  },
  inner: {
    maxWidth: 1100,
    margin: '0 auto',
    padding: '44px 12px 34px',
    color: IVORY,
  },
  kicker: {
    display: 'inline-block',
    color: GOLD,
    fontWeight: 800,
    letterSpacing: 0.6,
    marginBottom: 6,
  },
  title: {
    margin: '0 0 10px',
    fontFamily: 'serif',
    // fluid between ~28px and ~40px
    fontSize: 'clamp(28px, 4vw, 40px)',
    lineHeight: 1.1,
  },
  points: {
    listStyle: 'none',
    padding: 0,
    margin: '0 0 18px',
    color: WARM_GRAY,
    display: 'grid',
    gap: 6,
    fontSize: 16,
  },
  actions: { display: 'flex', gap: 10, flexWrap: 'wrap' },
  btnPrimary: {
    background: GOLD,
    color: NAVY,
    border: 'none',
    borderRadius: 12,
    padding: '12px 16px',
    fontWeight: 800,
    cursor: 'pointer',
  },
  btnGhost: {
    background: 'transparent',
    color: GOLD,
    border: `1px solid ${GOLD}`,
    borderRadius: 12,
    padding: '12px 16px',
    fontWeight: 800,
    cursor: 'pointer',
  },
  starGlowTL: {
    position: 'absolute',
    top: -160,
    left: -160,
    width: 360,
    height: 360,
    borderRadius: '50%',
    background: GOLD,
    filter: 'blur(64px)',
    opacity: 0.18,
    pointerEvents: 'none',
  },
  starGlowBR: {
    position: 'absolute',
    bottom: -200,
    right: -200,
    width: 420,
    height: 420,
    borderRadius: '50%',
    background: GOLD,
    filter: 'blur(72px)',
    opacity: 0.14,
    pointerEvents: 'none',
  },
};
// ==========================
// End Version 3 — Hero.js
// ==========================
